import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import MainPage from './pages/MainPage';
import Tokenomics from "./pages/Tokenomics"

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route exact path="/" element={<MainPage />} />
          <Route exact path="/tokenomics" element={<Tokenomics />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
